<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("RESELLER_PRODUCTS.ADD_RESELLER_PRODUCT") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <reseller-product-form
              :loading="loading"
              :resellerProductData="resellerProduct"
              :formErrors="formErrors"
              @resellerProductSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultResellerProduct from "./defaultResellerProduct";
import ResellerProductForm from "./partials/ResellerProductForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ResellerProductForm,
  },

  mixins: [alertLeave],

  data() {
    const resellerProduct = cloneDeep(defaultResellerProduct);
    return {
      resellerProduct: resellerProduct,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List ResellerProducts" });
    },

    viewResellerProduct(resellerProduct) {
      this.alertLeave = false;
      this.$router.push({
        name: "View ResellerProduct",
        params: { id: resellerProduct.id },
      });
    },

    async handleSubmit(resellerProduct) {
      this.loading = true;

      const resellerProductData = cloneDeep(resellerProduct);
      delete resellerProductData.id;

      try {
        await this.$store.dispatch("resellerProducts/add", resellerProductData);
        this.$notify({
          type: "success",
          message: this.$t("RESELLER_PRODUCTS.RESELLER_PRODUCT_ADDED"),
        });
        const resellerProduct = await this.$store.getters[
          "resellerProducts/resellerProduct"
        ];
        this.viewResellerProduct(resellerProduct);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        const resellerProduct = await this.$store.getters[
          "resellerProducts/resellerProduct"
        ];
        if (resellerProduct.id) {
          await this.$store.dispatch(
            "resellerProducts/destroy",
            resellerProduct.id
          );
        }
        this.loading = false;
      }
    },
  },
};
</script>
